import * as net from 'util/Net';

export interface AuthorizeOAuthClientRequest {
  response_type: string;
  client_id: string;
  redirect_uri: string;
  state?: string | null;
  code_challenge?: string | null;
  code_challenge_method?: string | null;
  scope?: string | null;
}

interface AuthorizeOAuthClientResponse {
  location: string;
}

export function authorizeOAuthClient(
  data: AuthorizeOAuthClientRequest
): Promise<AuthorizeOAuthClientResponse> {
  return net.postJSONPromise({url: '/oauth/authorize', data});
}
